import React from 'react';
import { createRoot, type RootOptions } from 'react-dom/client';
import styled from 'styled-components';
import { Notifications, token } from '@bynder/design-system';

import { AbilityContext } from './abilities/Can';
import ability from './abilities/ability';
import { Main } from './connectors/Main';
import MessageBox from './components/MessageBox';
import { reportReactError } from './helpers/reportReactError';
import { rootHeader as rootHeaderSelector, rootMessageBox as rootMessageSelector } from './roots';

const containerHeader = document.querySelector(rootHeaderSelector);
const containerMessageBox = document.querySelector(rootMessageSelector);

const Canary = styled.div`
	position: fixed;
	left: ${token.layoutSpacing2};
	bottom: ${token.layoutSpacing2};
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: ${token.spacing3} ${token.spacing5};
	background-color: ${token.orange900};
	color: ${token.orange100};
	border-radius: ${token.radiusPill};
`;

const isCanary = !!window.bynder.canary;

// React 19 no longer re-throws render errors, so nothing reports them unless we do. See
// helpers/reportReactError.ts.
const reactErrorHandlers: Pick<RootOptions, 'onUncaughtError' | 'onCaughtError'> = {
	onUncaughtError: reportReactError('uncaught'),
	onCaughtError: reportReactError('caught'),
};

if (containerHeader) {
	const rootHeader = createRoot(containerHeader, reactErrorHandlers);
	rootHeader.render(
		<>
			<AbilityContext.Provider value={ability}>
				<Main />
			</AbilityContext.Provider>
			<Notifications />
			{isCanary && <Canary>Canary build #{window.bynder.canary}</Canary>}
		</>,
	);
}

if (containerMessageBox) {
	const rootMessageBox = createRoot(containerMessageBox, reactErrorHandlers);
	rootMessageBox.render(<MessageBox />);
}
